import React, { useState } from "react";
import { Link ,useNavigate, useLocation  } from 'react-router-dom'
import HeaderStyle from '../../Styles/Header.module.css';
import { FaEye, FaEyeSlash  } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { login, getForgetPasswordAPI } from "../../../services/routes.services";
import { useDispatch } from 'react-redux';
import { userlogin } from '../../../store/authSlice';

const LoginPopup = ({ onClose })=>{
    const [loginShow, setLoginShow] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formDataLogin, setFormDataLogin] = useState({ email: '', password: '', userType: 'alumini' });
    const [errors, setErrors] = useState({});
    const [loginError, setLoginError] = useState('');
    const [forget, setForget]= useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const from = location.state?.from?.pathname || '';
    const [requestMsg, setRequestMsg]= useState('')
    // const { isAuthenticated, user, token } = useSelector((state) => state.auth);

    const loginCloseHandler = ()=>{
        setLoginShow(false)
        setShowPassword(false)
    }
    const passwordHandler=()=>{
        if(showPassword === false){
            setShowPassword(true)
        }else{
            setShowPassword(false)
        }
    }

    const handleChangeLogin = (e) => {
        //alert(e.target.value)
        setFormDataLogin({ ...formDataLogin, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: '' });
        setLoginError('');
    };

    const validate = () => {
        const newErrors = {};
        if (!formDataLogin.email) newErrors.email = 'Email is required';
        if (formDataLogin.email && !/\S+@\S+\.\S+/.test(formDataLogin.email)) newErrors.email = 'Email address is invalid';
        if (!formDataLogin.password) newErrors.password = 'Password is required';
        return newErrors;
    };
   
    const handleAluminiLogin = async (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        try {
            // formDataLogin.append('userType', 'alumini');
            //setFormDataLogin({ ...formDataLogin, 'userType': 'alumini' });
            
            const response = await login(formDataLogin);
            
            if(response.message != "Invalid Password"){
            console.log('Login successful:', response.user);
            localStorage.setItem('token', response.token);
            localStorage.setItem('userDetail', response.user);

            

            const user = response.user;
            const token = response.token;

            const userState = {
                isAuthenticated: true,
                user: user,
                token: token,
            };
            localStorage.setItem('authData', JSON.stringify(userState));
             // Dispatch login action
             console.log(response);
           
            dispatch(userlogin({user, token }));
            navigate(from, { replace: true });
    
            onClose()
        }
        else{
            setLoginError(  response.message)
        }
            
        } catch (error) {
            console.error('There was an error logging in!', error);
            setLoginError(error.response?.data?.error || 'An error occurred while logging in');
        }
    };

    const forgetPasswordHandler = async (e) => {
        e.preventDefault();
    
        let passErrors = {};
    
        if (!formDataLogin.email) {
            passErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formDataLogin.email)) {
            passErrors.email = 'Invalid email format';
        }
    
        setErrors(passErrors);
    
        if (Object.keys(passErrors).length === 0) {
            try {
                const res = await getForgetPasswordAPI({ email: formDataLogin.email });
                if (res.data.success === true) {
                    setRequestMsg(res.data.message)
                } else {
                    setErrors({ email: res.data.message }); 
                }
            } catch (error) {
                setErrors({ email: + error });
            }
        }
    };
    
    

    const forgetScreenHandler=()=>{
        setForget(true);
    }
    const loginScreenHandler=()=>{
        setForget(false);
    }
    return(
        <div className={HeaderStyle.loginWindow}>
                    <div className={HeaderStyle.loginContainer}>
                        <button onClick={onClose} type="button" className={'loginBtnClose ' + HeaderStyle.closeLogin}><IoMdClose /></button>
                        {!forget ?
                            <>
                                <h3>Login</h3>
                                <form onSubmit={handleAluminiLogin}  method="post">
                                    <div className={HeaderStyle.inputBox}>
                                        <input type="text" name="email" placeholder="Email Id / Phone Number"   value={formDataLogin.email} 
                                            onChange={handleChangeLogin}
                                            />
                                        {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
                                    </div>
                                    <div className={HeaderStyle.inputBox}>
                                        <input type={showPassword ? 'text' : 'password'} placeholder="Password" name="password" value={formDataLogin.password} 
                                            onChange={handleChangeLogin}
                                            />
                                        <button type="button" onClick={passwordHandler}>
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                        {errors.password && <p style={{ color: 'red' }}>{errors.password}</p>}
                                    </div>
                                    <div className={HeaderStyle.forgetPass}>
                                        <button type='button' className={HeaderStyle.linkBtn} onClick={forgetScreenHandler}>Forgot your Password?</button>
                                    </div>
                                    <div className={HeaderStyle.submitBtn}>
                                    {loginError && <p style={{ color: 'red' }}>{loginError}</p>}
                                        <button type="submit" >Login</button>
                                    </div>
                                    <div className={HeaderStyle.newAccount}>
                                        <p>Do not have an account ?</p>
                                        <Link to='/registration' onClick={loginCloseHandler}>Create New Account</Link>
                                    </div>
                                </form>    
                            </>
                            :
                            <>
                            <h3>Forgot Password</h3>
                            {requestMsg ? (
                                <p style={{ color: "green", textAlign:'center' }}>{requestMsg}</p>
                                ) : (
                                <div>
                                    <div className={HeaderStyle.inputBox}>
                                        <input type="text" name="email" placeholder="Email Id / Phone Number"  value={formDataLogin.email} onChange={handleChangeLogin}/>
                                        {errors.email && <p style={{ color: 'red' }}>{errors.email}</p>}
                                    </div>
                                    {/* <div className={HeaderStyle.forgetPass}>
                                        <button type='button' className={HeaderStyle.linkBtn} onClick={loginScreenHandler}>Login</button>
                                    </div> */}
                                    <div className={HeaderStyle.submitBtn}>
                                        <button type="button" onClick={forgetPasswordHandler}>Submit</button>
                                    </div>
                                    <div className={HeaderStyle.newAccount}>
                                        <p>Do not have an account ?</p>
                                        <Link to='/registration' onClick={loginCloseHandler}>Create New Account</Link>
                                    </div>
                                </div>
                            )}
                            
                            </>
                        }
                    </div>
                </div>
    )
}

export default LoginPopup;